import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangas';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer">
              <span className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </span>
              <span className="text-lg font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
                番茄漫画
              </span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed">
              追更漫画连载更新，提供最新话追漫提醒，免费全集完结韩漫日漫国漫，流畅下拉式滚动在线阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-categories" className="cursor-pointer">漫画分类</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-links" className="cursor-pointer">快速链接</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li><Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">首页</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link></li>
              <li><a href="#contact" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">联系我们</a></li>
              <li><a href="#privacy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">隐私政策</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-950 mb-4">
              <a href="#footer-contact" className="cursor-pointer">联系方式</a>
            </h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-mail-line"></i>
                <span>contact@fanqiemanhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-wechat-line"></i>
                <span>番茄漫画官方</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-600">
                <i className="ri-weibo-line"></i>
                <span>@番茄漫画</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 番茄漫画. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#weibo" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#wechat" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#bilibili" className="text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer" aria-label="哔哩哔哩">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}